import Loading from '../../../Common/Loading';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';
import { AnnualEvolutionProcedures } from './AnnualEvolutionProcedures';
import { EvolutionByProcedures } from './EvolutionByProcedures';

export const Charts = () => {
    const { isLoading } = useProceduresChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionProcedures />
                <EvolutionByProcedures />
            </div>
        </>
    );
};
